export const appHead = {"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"description","content":"Wir erstellen Digitale Anwendungen, die wirklich nützlich sind. Die Menschen miteinander verbinden. Die bewegen. Das ist unsere Vision einer vernetzten Welt."},{"charset":"utf8"},{"name":"msapplication-TileColor","content":"#14213D"},{"name":"msapplication-TileImage","content":"/mstile-144x144.png"},{"name":"theme-color","content":"#14213D"},{"name":"robots","content":"max-image-preview:large, index, follow, max-snippet:-1, max-video-preview:-1"},{"name":"geo.region","content":"DE-NW"},{"name":"geo.placename","content":"Langenfeld"},{"name":"geo.position","content":"51.134572322006804;6.986427083547942"},{"name":"ICBM","content":"51.134572322006804, 6.986427083547942"},{"name":"author","content":"dreißigelf"},{"name":"publisher","content":"dreißigelf"},{"name":"copyright","content":"dreißigelf"},{"name":"language","content":"de"},{"name":"op:locale","content":"de_DE"},{"name":"op:type","content":"website"},{"name":"op:site_name","content":"dreißigelf"},{"name":"op:email","content":"info@dreissigelf.de"},{"name":"op:title","content":"dreißigelf"},{"name":"op:description","content":"Wir erstellen Digitale Anwendungen, die wirklich nützlich sind. Die Menschen miteinander verbinden. Die bewegen. Das ist unsere Vision einer vernetzten Welt."},{"name":"op:url","content":"https://dreissigelf.de"},{"name":"og:image","content":"https://dreissigelf.de/dreissigelf.jpg"},{"name":"og:title","content":"dreißigelf"},{"name":"og:description","content":"Wir erstellen Digitale Anwendungen, die wirklich nützlich sind. Die Menschen miteinander verbinden. Die bewegen. Das ist unsere Vision einer vernetzten Welt."},{"name":"og:url","content":"https://dreissigelf.de"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https://dreissigelf.de/dreissigelf.jpg"},{"name":"twitter:title","content":"dreißigelf"},{"name":"twitter:description","content":"Wir erstellen Digitale Anwendungen, die wirklich nützlich sind. Die Menschen miteinander verbinden. Die bewegen. Das ist unsere Vision einer vernetzten Welt."},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"style":"background-color: #14213D;","lang":"de"},"charset":"utf8"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false